export const getDiscountPercentage = (prev, current) => {
  if (prev && current) {
    return Math.floor(((prev - current)/prev)*100);
  } else {
    return false;
  }
};
